import { j as e } from "./jsx-runtime-e6RZPHeG.js";
import { memo as i } from "react";
const s = ({
  title: l,
  titleId: c,
  ...o
}) => /* @__PURE__ */ e.jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 1024 1024",
    role: "img",
    "aria-labelledby": c,
    ...o,
    children: [
      l ? /* @__PURE__ */ e.jsx("title", { id: c, children: l }) : null,
      /* @__PURE__ */ e.jsx(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          d: "M858.929 547.242 728.468 677.63c-5.077 5.139-11.879 7.739-18.617 7.739s-13.547-2.605-18.681-7.739c-10.344-10.282-10.344-26.962 0-37.303l127.126-127.126L691.17 386.075c-10.344-10.282-10.344-26.962 0-37.37 10.344-10.282 27.026-10.282 37.303 0l130.461 130.461c18.754 18.821 18.754 49.312 0 68.068zm-222.012-180.11L433.926 685.368c-5.077 7.878-13.616 12.148-22.284 12.148-4.87 0-9.804-1.331-14.215-4.14-12.273-7.811-15.878-24.152-8.001-36.368l203.056-318.304c7.811-12.348 24.152-15.817 36.368-8.076 12.273 7.878 15.878 24.152 8.076 36.501zM332.898 640.326c10.282 10.344 10.282 27.026 0 37.303-5.206 5.139-11.942 7.739-18.681 7.739-6.802 0-13.472-2.605-18.617-7.739L165.212 547.241c-18.821-18.754-18.821-49.25 0-68.068L295.6 348.712c10.344-10.282 26.962-10.282 37.303 0 10.282 10.405 10.282 27.095 0 37.37L205.777 513.208l127.126 127.126zm582.217-528.032H108.886c-39.173 0-70.934 31.832-70.934 70.934v657.483c0 39.235 31.761 70.996 70.934 70.996h806.229c39.235 0 70.934-31.761 70.934-70.996V183.228c0-39.102-31.695-70.934-70.934-70.934",
          clipRule: "evenodd"
        }
      )
    ]
  }
), n = i(s);
export {
  n as default
};
